import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cls = "mt-1 w-full rounded-lg border border-[#D9D9D3] bg-white px-3 py-2 text-sm text-[#111] focus:outline-none focus:border-[#4CCC06] disabled:opacity-60";

export const PropertyPicker = ({ customerId, value, onChange, disabled }) => {
  const [props, setProps] = useState([]);
  useEffect(() => { if (customerId) api(`/billing/customers/${customerId}`).then((c) => setProps(c.properties || [])).catch(() => setProps([])); }, [customerId]);
  if (!props.length) return null;
  return (
    <label className="block text-xs text-[#888]">Service property
      <select className={cls} disabled={disabled} value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid="doc-property-select">
        <option value="">Main address</option>
        {props.map((p) => <option key={p.id} value={p.id}>{p.label ? `${p.label}: ` : ""}{p.address}</option>)}
      </select>
    </label>
  );
};

export const DepositFields = ({ f, setF, disabled, total, cur }) => (
  <div className="grid gap-2 md:grid-cols-3" data-testid="doc-deposit-fields">
    <label className="text-xs text-[#888]">Deposit
      <select className={cls} disabled={disabled} value={f.deposit_type} onChange={(e) => setF({ ...f, deposit_type: e.target.value })} data-testid="doc-deposit-type">
        <option value="amount">Fixed amount</option><option value="pct">Percent of total</option>
      </select>
    </label>
    {f.deposit_type === "pct"
      ? <label className="text-xs text-[#888]">Percent of quote total (incl. tax)<input className={cls} disabled={disabled} type="number" min="0" max="100" step="1" value={f.deposit_pct} onChange={(e) => setF({ ...f, deposit_pct: e.target.value })} data-testid="doc-deposit-pct" />
          <span className="text-[11px] text-[#777]" data-testid="doc-deposit-pct-amount">= {cur}{((total || 0) * (+f.deposit_pct || 0) / 100).toFixed(2)}</span></label>
      : <label className="text-xs text-[#888]">Deposit amount ({cur})<input className={cls} disabled={disabled} type="number" min="0" step="0.01" value={f.deposit_amount} onChange={(e) => setF({ ...f, deposit_amount: e.target.value })} data-testid="doc-deposit-input" /></label>}
    <label className="text-xs text-[#888]">Deposit due by (optional)<input className={cls} disabled={disabled} type="date" value={f.deposit_due_date || ""} onChange={(e) => setF({ ...f, deposit_due_date: e.target.value })} data-testid="doc-deposit-due" /></label>
  </div>
);

export const TemplatePicker = ({ onPick, disabled }) => {
  const [list, setList] = useState(null);
  const open = () => api("/billing/templates").then(setList).catch(() => setList([]));
  if (disabled) return null;
  if (!list) return <button type="button" onClick={open} className="text-xs font-bold text-[#2E8B00]" data-testid="doc-template-open">Start from an ALR template</button>;
  return (
    <div className="rounded-lg border border-[#D9D9D3] p-3" data-testid="doc-template-list">
      {!list.length && <p className="text-xs text-[#777]">ALR hasn't published any templates yet.</p>}
      {list.map((t) => <button type="button" key={t.id} onClick={() => { onPick(t); setList(null); }} className="block w-full rounded-md px-2 py-1.5 text-left text-sm hover:bg-[#F0F0EA]" data-testid={`doc-template-${t.key}`}>{t.name} <span className="text-[11px] text-[#777]">v{t.version}{t.category ? ` · ${t.category}` : ""}</span></button>)}
    </div>
  );
};

// a template fills the wording and the optional services; prices always come from the builder or the franchisee
export const fromTemplate = (t, f, lines) => {
  const notes = [t.scope, t.measurement_requirements?.length ? `Measurements needed: ${t.measurement_requirements.join("; ")}` : "", t.exclusions ? `Not included: ${t.exclusions}` : ""].filter(Boolean).join("\n\n");
  const opts = (t.optional_services || []).map((o) => ({ id: null, description: o.description, quantity: 1, unit_price: 0, unit: o.unit, category: "service", optional: true, selected: false }));
  return { f: { ...f, title: f.title || t.name, notes, disclaimer: t.terms || f.disclaimer, template_id: t.id, template_version: t.version },
           lines: [...lines.filter((l) => l.description.trim()), ...opts] };
};
